// App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './Translations/LenguageContext';
import './App.css';
import './AppMobile.css';
import MainFrameHome from './Website/MainFrame';
import ScrollToTop from './Functions/ScrollToTop';
import Waitlist from './Waitlist/Waitlist';
import MainForm from './Form/MainForm';


const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MainFrameHome />} />
    <Route path="/join-waitlist" element={<Waitlist />} />
    <Route path="/m-research/:section" element={<MainForm />} />
  </Routes>
);

const App = () => {
  return (
    <LanguageProvider>
      <Router>
          <ScrollToTop />
          <AppRoutes />
          
      </Router>
    </LanguageProvider>
  );
};

export default App;
